<template>
    <div :id="modalKey" v-show="isActiveModal()">
      <div :class="['modal', classStyle ]">
        <div class="modal__content">
          <button class="btn modal-close" @click.prevent="closeModal()"><i class="icon-close"></i></button>
          <div :class="['modal__header', headerStyle]">
            <slot name="header"></slot>
          </div>
          <div :class="['modal__body', bodyStyle]">
            <slot name="body"></slot>
          </div>
          <slot name="waiting"></slot>
          <div :class="['modal__footer', footerStyle]">
            <slot name="footer"></slot>
          </div>
        </div>
        <slot name="error"></slot>
      </div>
      <div class="modal-overlay" @click.prevent="closeModal()" style="display: block"></div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'generic-modal',
  props: {
    modalKey: String,
    classStyle: String,
    headerStyle: String,
    bodyStyle: String,
    footerStyle: String,
  },
  created() {
    this.initModal();
  },
  beforeDestroy() {
    this.unregisterModal(); // remove latest modal from stack
  },
  methods: {
    ...mapMutations('common', [
      'registerModal',
      'unregisterModal',
    ]),
    initModal() {
      this.registerModal({ value: this.modalKey }); // add modal to stack
    },
    closeModal() {
      // eslint-disable-next-line
      console.log('click for: ' + this.modalKey);
      this.$emit('close'); // inform parent
    },
    isActiveModal() {
      return this.getActiveModal === this.modalKey;
    },
  },
  computed: {
    ...mapGetters('common', [
      'getActiveModal',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/shared/GenericModal.vue